import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./tools.css";

import one from "../../assets/dotnetimages/tools/Dapper.png";
import two from "../../assets/dotnetimages/tools/GraphQL.png";
import three from "../../assets/dotnetimages/tools/IdentityServer.png";
import four from "../../assets/dotnetimages/tools/Jenkins.png";
import five from "../../assets/dotnetimages/tools/NUnit.png";
import six from "../../assets/dotnetimages/tools/NXMTtest.png";
import seven from "../../assets/dotnetimages/tools/NuGet.png";
import eight from "../../assets/dotnetimages/tools/OWASP ZAP.png";
import nine from "../../assets/dotnetimages/tools/Swagger.png";
import ten from "../../assets/dotnetimages/tools/asp.png";
import elven from "../../assets/dotnetimages/tools/blazor.png";
import twele from "../../assets/dotnetimages/tools/entity.png";
import thirteen from "../../assets/dotnetimages/tools/metest.png";
import fourteen from "../../assets/dotnetimages/tools/visal.png";
import sixteen from "../../assets/dotnetimages/tools/wcf.jpg";

const clients = [
  { src: one, alt: "Apache JMeter" },
  { src: two, alt: "Appium" },
  { src: three, alt: "Appium JPG" },
  { src: four, alt: "Cucumber" },
  { src: five, alt: "Java" },
  { src: six, alt: "Jenkins" },
  { src: seven, alt: "JUnit" },
  { src: eight, alt: "LoadRunner" },
  { src: nine, alt: "Postman" },
  { src: ten, alt: "Selenium" },
  { src: elven, alt: "SoapUI" },
  { src: twele, alt: "TestNG" },
  { src: twele, alt: "TestNG" },
  { src: thirteen, alt: "TestNG" },
  { src: fourteen, alt: "TestNG" },
  { src: sixteen, alt: "TestNG" },


];

function Tools() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      <section style={{ marginTop: "50px" }}>
        <div className="headlines-for-all">
          <h4     data-aos="fade-up" >
            <span>Tools </span> Covered
          </h4>
          <p     data-aos="fade-up">
         Gain hands-on experience with the most in-demand .NET technologies, frameworks, and development tools used by enterprise software developers.
          </p>
        </div>
      </section>

      <section className="our-clients-section">
        <div className="our-clients-container">
          <motion.div
            className="our-clients-track"
            animate={{ x: ["0%", "-100%"] }}
            transition={{
              ease: "linear",
              duration: 100,
              repeat: Infinity,
            }}
          >
            {[...clients, ...clients].map((client, i) => (
              <div
                className="client-item"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 150} // DELAY ONE-BY-ONE
              >
                <img src={client.src} alt={client.alt} />
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}

export default Tools;
